import { getLabelChoiceValue, LabelChoice } from '@scale/shared/types/params/annotation';
import React from 'react';
import AttributeCheckboxInput from './AttributeCheckboxInput';

interface AttributeCheckboxMultiSelectProps {
  choices: LabelChoice[];
  selectedChoices?: string[];
  handleSelect: (choices: string[]) => void;
  isReadOnly?: boolean;
}

export const AttributeCheckboxMultiSelect: React.FC<AttributeCheckboxMultiSelectProps> = ({
  choices,
  selectedChoices,
  handleSelect,
  isReadOnly,
}) => {
  const handleSingleSelect = (choice: string) => {
    if (!selectedChoices) {
      handleSelect([choice]);
    } else if (selectedChoices.includes(choice)) {
      handleSelect(selectedChoices.filter(c => c !== choice));
    } else {
      handleSelect([...selectedChoices, choice]);
    }
  };

  return (
    <div style={{ maxHeight: '150px', overflow: 'scroll' }}>
      {choices.map(c => {
        const choiceValue = getLabelChoiceValue(c);

        return (
          <AttributeCheckboxInput
            key={choiceValue}
            choice={c}
            isReadOnly={isReadOnly}
            selected={selectedChoices ? selectedChoices.includes(choiceValue) : false}
            handleSelect={handleSingleSelect}
          />
        );
      })}
    </div>
  );
};
